// src/utils/common.js

// 스크롤과 리사이즈를 동시에 처리하는 함수
function handleScrollAndResize() {
  const scrollPosition = window.scrollY;
  const headerWrap = document.querySelector(".header_inner");
  const gnbWrap = document.querySelector(".gnb_wrap");
  const headerWrapElement = document.querySelector(".header_wrap");
  const gridContent = document.querySelector(".header_inner .grid_content");

  // 768px 이하일 때
  if (window.innerWidth <= 768) {
    // 스크롤이 있을 때 header를 위로 올리기
    if (scrollPosition > 0) {
      headerWrap.style.transform = `translateY(-44px)`;
      document.body.classList.add("scroll");
    } else {
      headerWrap.style.transform = `translateY(0)`;
      document.body.classList.remove("scroll");
    }

    // GNB를 header_wrap의 마지막 자식으로 이동
    if (gnbWrap && gnbWrap.parentElement !== headerWrapElement) {
      headerWrapElement.appendChild(gnbWrap);
    }
  } else {
    // 화면 크기가 768px 초과일 때
    if (gnbWrap && gnbWrap.parentElement !== gridContent) {
      gridContent.appendChild(gnbWrap); // grid_content 마지막 자식으로 이동
    }

    // transform 리셋
    headerWrap.style.transform = `translateY(0)`;
  }
}

// 리스너 추가
export function addListeners() {
  handleScrollAndResize();
  window.addEventListener("scroll", handleScrollAndResize);
  window.addEventListener("resize", handleScrollAndResize);
}

// 리스너 제거
export function removeListeners() {
  window.removeEventListener("scroll", handleScrollAndResize);
  window.removeEventListener("resize", handleScrollAndResize);
}

export function openLayer() {
  document.querySelectorAll(".open_click").forEach((button) => {
    const layer = button.nextElementSibling;
    if (layer && layer.classList.contains("layer_open")) {
      button.addEventListener("click", function (event) {
        document.querySelectorAll(".open_click").forEach((btn) => {
          if (btn !== button) {
            btn.setAttribute("aria-expanded", "false");
            const otherLayer = btn.nextElementSibling;
            if (otherLayer && otherLayer.classList.contains("layer_open")) {
              otherLayer.classList.remove("on");
            }
          }
        });
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", isExpanded ? "false" : "true");
        layer.classList.toggle("on", !isExpanded);
        event.stopPropagation();
      });
    }
  });
  document.addEventListener("click", function (event) {
    if (event.target.closest(".layer_open")) return;
    document.querySelectorAll(".open_click").forEach((button) => {
      button.setAttribute("aria-expanded", "false");
      const layer = button.nextElementSibling;
      if (layer && layer.classList.contains("layer_open")) {
        layer.classList.remove("on");
      }
    });
  });
}

export function accordion() {
  /** 아코디언 구조 .accordion > .acd_tit + .acd_cnt 가 한 세트 */
  const accordions = document.querySelectorAll(".accordion");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".acd_cnt");
    accordion.classList.add("on");
    content.style.maxHeight = "none";
  };
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".acd_cnt");
    accordion.classList.remove("on");
    content.style.maxHeight = null;
  };
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".acd_tit");
    const content = accordion.querySelector(".acd_cnt");

    intro.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion);
      }
    };
  });
  // openAccordion 함수를 반환하여 특정 항목을 수동으로 열 수 있게 함
  return { openAccordion, closeAccordion };
}

/** moveTop */
export function moveTop() {
  var footerQuick = document.querySelector(".ft_quick");
  var moveTopButton = document.querySelector(".move_top");

  function updateButtonVisibility() {
    var scrollY = window.scrollY;
    var windowHeight = window.innerHeight;

    // 스크롤이 화면 높이보다 많이 내려가면 move_top 버튼 활성화
    if (scrollY > windowHeight) {
      footerQuick.classList.add("on");
    } else {
      footerQuick.classList.remove("on");
    }
  }

  function scrollToTop() {
    var startTime;
    var duration = 300;
    var startScrollY = window.scrollY;
    var endScrollY = 0;

    function animateScroll(currentTime) {
      if (!startTime) {
        startTime = currentTime;
      }

      var elapsedTime = currentTime - startTime;
      var progress = Math.min(elapsedTime / duration, 1);

      window.scrollTo(0, startScrollY + (endScrollY - startScrollY) * progress);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }

    requestAnimationFrame(animateScroll);
  }

  window.addEventListener("scroll", updateButtonVisibility);
  moveTopButton.addEventListener("click", scrollToTop);

  // 초기 상태 설정
  updateButtonVisibility();
}

export function moveTop2() {
  var footerQuick = document.querySelector(".ft_quick");
  var moveTopButton = document.querySelector(".move_top");
  var footer = document.querySelector("footer");

  function updateButtonVisibility() {
    var scrollY = window.scrollY;
    var windowHeight = window.innerHeight;

    // 기본 노출 조건
    if (scrollY > windowHeight) {
      footerQuick.classList.add("on");
    } else {
      footerQuick.classList.remove("on");
    }

    if (footer) {
      var footerTop = footer.offsetTop;
      var currentBottom = scrollY + windowHeight;

      // 화면 하단이 footer 시작점에 닿으면
      if (currentBottom > footerTop) {
        footerQuick.classList.add("footer_on");
      } else {
        footerQuick.classList.remove("footer_on");
      }
    }
  }

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  window.addEventListener("scroll", updateButtonVisibility);
  moveTopButton.addEventListener("click", scrollToTop);

  updateButtonVisibility();
}

// 스크롤 시 클래스명 붙이기
function updateScrollClass() {
  const isScrolled = window.scrollY > 0;
  document.body.classList.toggle("scroll", isScrolled);

  const header = document.querySelector("header");
  if (header) {
    header.classList.toggle("scroll", isScrolled);
  }
}

window.addEventListener("scroll", updateScrollClass);
